import {FirmUserRoleStatus, Role} from '@sollapay/enums';

interface TeamStatusConfig {
  labelKey: string;
  variant: 'success' | 'info' | 'neutral';
}

export const TEAM_STATUS_CONFIG: Record<FirmUserRoleStatus, TeamStatusConfig> = {
  [FirmUserRoleStatus.ACTIVE]: {labelKey: 'status.active', variant: 'success'},
  [FirmUserRoleStatus.PENDING]: {labelKey: 'status.pending', variant: 'info'},
  [FirmUserRoleStatus.REVOKED]: {labelKey: 'status.revoked', variant: 'neutral'}
};

/**
 * Role identity dot color, per the Figma role badge design — fixed per-role recognition
 * colors (`--role-firm-*` tokens in `globals.css`), not semantic status colors. Only covers
 * firm-assignable roles — `firm_support` renders as a `ProtectedRoleBadge` instead, which
 * has no color dot. Phase 1 has no custom (per-firm) roles, so an unresolved key falls back
 * to a neutral gray dot.
 */
export const ROLE_DOT_COLOR_CLASS: Record<string, string> = {
  [Role.FIRM_ADMIN]: 'bg-role-firm-admin',
  [Role.FIRM_TRUSTEE]: 'bg-role-firm-trustee',
  [Role.FIRM_VIEWER]: 'bg-role-firm-viewer',
  [Role.FIRM_MEMBER]: 'bg-role-firm-member'
} satisfies Record<Exclude<Role, Role.FIRM_SUPPORT>, string>;

export const DEFAULT_ROLE_DOT_COLOR_CLASS = 'bg-fg-disabled';
